export const BASE_URL = 'https://www.e-metal.com.tr';

// ============================================================
// KATEGORİ SAYFALARI (ItemList Schema)
// ============================================================

export const bakırKategoriSchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Bakır Ürünleri',
  description:
    'Bakır boru, çubuk, kare çubuk, kangal boru, kaynak teli, lama, levha, şerit ve baralık malzeme çeşitleri',
  url: `${BASE_URL}/tr/urunlerimiz/bakir`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Bakır Boru',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-boru`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 2,
    //   name: 'Bakır Çubuk',
    //   url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-cubuk`,
    // },
    // {
    //   '@type': 'ListItem',
    //   position: 3,
    //   name: 'Bakır Kare Çubuk',
    //   url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-kare-cubuk`,
    // },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Bakır Kangal Boru',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-kangal-boru`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: 'Bakır Kaynak Teli',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-kaynak-teli`,
    },
    {
      '@type': 'ListItem',
      position: 4,
      name: 'Bakır Lama',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-lama`,
    },
    {
      '@type': 'ListItem',
      position: 5,
      name: 'Bakır Levha',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-levha`,
    },
    {
      '@type': 'ListItem',
      position: 6,
      name: 'Bakır Şeritler',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/bakir-seritler`,
    },
    {
      '@type': 'ListItem',
      position: 7,
      name: 'Baralık ve Topraklamalık Malzeme',
      url: `${BASE_URL}/tr/urunlerimiz/bakir/baralik-ve-topraklamalik-malzeme`,
    },
  ],
};

export const pirincKategoriSchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Pirinç Ürünleri',
  description:
    'Pirinç çubuk, altıköşe çubuk, kare çubuk, kaynak teli, lama ve levha çeşitleri',
  url: `${BASE_URL}/tr/urunlerimiz/pirinc`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Pirinç Çubuk',
      url: `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-cubuk`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 2,
    //   name: 'Pirinç Altıköşe Çubuk',
    //   url: `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-altikose-cubuk`,
    // },
    // {
    //   '@type': 'ListItem',
    //   position: 3,
    //   name: 'Pirinç Kare Çubuk',
    //   url: `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-kare-cubuk`,
    // },
    // {
    //   '@type': 'ListItem',
    //   position: 4,
    //   name: 'Pirinç Kaynak Teli',
    //   url: `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-kaynak-teli`,
    // },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Pirinç Lama',
      url: `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-lama`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 6,
    //   name: 'Pirinç Levha',
    //   url: `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-levha`,
    // },
  ],
};

export const aluminyumKategoriSchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Alüminyum Ürünleri',
  description: 'Alüminyum çubuk, kare çubuk, lama ve levha çeşitleri',
  url: `${BASE_URL}/tr/urunlerimiz/aluminyum`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Alüminyum Çubuk',
      url: `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-cubuk`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 2,
    //   name: 'Alüminyum Kare Çubuk',
    //   url: `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-kare-cubuk`,
    // },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Alüminyum Lama',
      url: `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-lama`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: 'Alüminyum Levha',
      url: `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-levha`,
    },
  ],
};

export const bronzKategoriSchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Bronz Ürünleri',
  description: 'Bronz çubuk çeşitleri toptan ve perakende satış',
  url: `${BASE_URL}/tr/urunlerimiz/bronz`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Bronz Çubuk',
      url: `${BASE_URL}/tr/urunlerimiz/bronz/bronz-cubuk`,
    },
  ],
};

export const copperCategorySchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Copper Products',
  description:
    'Copper pipe, rod, square rod, coil pipe, welding wire, busbar, sheet, strips and grounding material varieties',
  url: `${BASE_URL}/en/our-products/copper`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Copper Pipe',
      url: `${BASE_URL}/en/our-products/copper/copper-pipe`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 2,
    //   name: 'Copper Rod',
    //   url: `${BASE_URL}/en/our-products/copper/copper-rod`,
    // },
    // {
    //   '@type': 'ListItem',
    //   position: 3,
    //   name: 'Copper Square Rod',
    //   url: `${BASE_URL}/en/our-products/copper/copper-square-rod`,
    // },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Copper Coil Pipe',
      url: `${BASE_URL}/en/our-products/copper/copper-coil-pipe`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: 'Copper Welding Wire',
      url: `${BASE_URL}/en/our-products/copper/copper-welding-wire`,
    },
    {
      '@type': 'ListItem',
      position: 4,
      name: 'Copper Busbar',
      url: `${BASE_URL}/en/our-products/copper/copper-busbar`,
    },
    {
      '@type': 'ListItem',
      position: 5,
      name: 'Copper Sheet',
      url: `${BASE_URL}/en/our-products/copper/copper-sheet`,
    },
    {
      '@type': 'ListItem',
      position: 6,
      name: 'Copper Strips',
      url: `${BASE_URL}/en/our-products/copper/copper-strips`,
    },
    {
      '@type': 'ListItem',
      position: 7,
      name: 'Grounding and Busbar Material',
      url: `${BASE_URL}/en/our-products/copper/grounding-and-busbar-material`,
    },
  ],
};

export const brassCategorySchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Brass Products',
  description:
    'Brass rod, hexagonal rod, square rod, welding wire, busbar and sheet varieties',
  url: `${BASE_URL}/en/our-products/brass`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Brass Rod',
      url: `${BASE_URL}/en/our-products/brass/brass-rod`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 2,
    //   name: 'Brass Hexagonal Rod',
    //   url: `${BASE_URL}/en/our-products/brass/brass-hexagonal-rod`,
    // },
    // {
    //   '@type': 'ListItem',
    //   position: 3,
    //   name: 'Brass Square Rod',
    //   url: `${BASE_URL}/en/our-products/brass/brass-square-rod`,
    // },
    // {
    //   '@type': 'ListItem',
    //   position: 4,
    //   name: 'Brass Welding Wire',
    //   url: `${BASE_URL}/en/our-products/brass/brass-welding-wire`,
    // },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Brass Busbar',
      url: `${BASE_URL}/en/our-products/brass/brass-busbar`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 6,
    //   name: 'Brass Sheet',
    //   url: `${BASE_URL}/en/our-products/brass/brass-sheet`,
    // },
  ],
};

export const aluminumCategorySchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Aluminum Products',
  description: 'Aluminum rod, square rod, busbar and sheet varieties',
  url: `${BASE_URL}/en/our-products/aluminum`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Aluminum Rod',
      url: `${BASE_URL}/en/our-products/aluminum/aluminum-rod`,
    },
    // {
    //   '@type': 'ListItem',
    //   position: 2,
    //   name: 'Aluminum Square Rod',
    //   url: `${BASE_URL}/en/our-products/aluminum/aluminum-square-rod`,
    // },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Aluminum Busbar',
      url: `${BASE_URL}/en/our-products/aluminum/aluminum-busbar`,
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: 'Aluminum Sheet',
      url: `${BASE_URL}/en/our-products/aluminum/aluminum-sheet`,
    },
  ],
};

export const bronzeCategorySchema: ItemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Bronze Products',
  description: 'Bronze rod varieties wholesale and retail sales',
  url: `${BASE_URL}/en/our-products/bronze`,
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Bronze Rod',
      url: `${BASE_URL}/en/our-products/bronze/bronze-rod`,
    },
  ],
};

// ============================================================
// ÜRÜN SAYFALARI (Product Schema)
// ============================================================

const createProductSchema = (
  name: string,
  description: string,
  url: string,
  image: string,
) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: name,
  description: description,
  image: image || 'https://www.e-metal.com.tr/bakir.png',
  brand: {
    '@type': 'Brand',
    name: 'e-Metal',
  },
  offers: {
    '@type': 'Offer',
    priceCurrency: 'TRY',
    availability: 'https://schema.org/InStock',
    url: url,
    seller: {
      '@type': 'Organization',
      name: 'e-Metal',
      url: 'https://www.e-metal.com.tr',
    },
  },
});

// --- BAKIR ---
export const bakırBoruSchema = createProductSchema(
  'Bakır Boru',
  'Toptan ve perakende bakır boru satışı. Elektrik, ısıtma ve soğutma sistemleri için yüksek kaliteli bakır boru.',
  `${BASE_URL}/tr/urunlerimiz/bakir/bakir-boru`,
  'https://www.e-metal.com.tr/static/media/bakir-boru.d78d4b2c73c42c7ae3ca.png',
);

// export const bakırCubukSchema = createProductSchema(
//   'Bakır Çubuk',
//   'Toptan ve perakende bakır çubuk satışı. Elektrik iletkenliği yüksek bakır çubuk çeşitleri.',
//   `${BASE_URL}/tr/urunlerimiz/bakir/bakir-cubuk`,
//   'https://www.e-metal.com.tr/static/media/bakir-cubuk.c8f38262755011311999.png',
// );

// export const bakırKareCubukSchema = createProductSchema(
//   'Bakır Kare Çubuk',
//   'Toptan ve perakende bakır kare çubuk satışı. Farklı kesit ölçülerinde bakır kare çubuk.',
//   `${BASE_URL}/tr/urunlerimiz/bakir/bakir-kare-cubuk`,
//   'https://www.e-metal.com.tr/static/media/bakir-kare-cubuk.645ee5ab50bf9f92e1e8.png',
// );

export const bakırKangalBoruSchema = createProductSchema(
  'Bakır Kangal Boru',
  'Toptan ve perakende bakır kangal boru satışı. Klima ve soğutma sistemlerinde kullanılan bakır kangal boru.',
  `${BASE_URL}/tr/urunlerimiz/bakir/bakir-kangal-boru`,
  'https://www.e-metal.com.tr/static/media/bakir-kangal-boru.dd4302a10f25aee7944a.png',
);

// export const bakırKaynakTeliSchema = createProductSchema(
//   'Bakır Kaynak Teli',
//   'Toptan ve perakende bakır kaynak teli satışı. Yüksek iletkenlikli bakır kaynak teli çeşitleri.',
//   `${BASE_URL}/tr/urunlerimiz/bakir/bakir-kaynak-teli`,
// );

export const bakırLamaSchema = createProductSchema(
  'Bakır Lama',
  'Toptan ve perakende bakır lama satışı. Elektrik pano ve bara sistemleri için bakır lama.',
  `${BASE_URL}/tr/urunlerimiz/bakir/bakir-lama`,
  'https://www.e-metal.com.tr/static/media/bakir-lama.bb88238a18b4a7082e3c.png',
);

export const bakırLevhaSchema = createProductSchema(
  'Bakır Levha',
  'Toptan ve perakende bakır levha satışı. Farklı kalınlık ve boyutlarda bakır levha.',
  `${BASE_URL}/tr/urunlerimiz/bakir/bakir-levha`,
  'https://www.e-metal.com.tr/static/media/bakir-levha.bf81083fdd550df943e1.png',
);

export const bakırSeritlerSchema = createProductSchema(
  'Bakır Şeritler',
  'Toptan ve perakende bakır şerit satışı. Transformatör ve elektrik uygulamaları için bakır şerit.',
  `${BASE_URL}/tr/urunlerimiz/bakir/bakir-seritler`,
  'https://www.e-metal.com.tr/static/media/bakir-serit.b47b02df0221a83693e7.png',
);

export const baralikMalzemeSchema = createProductSchema(
  'Baralık ve Topraklamalık Malzeme',
  'Toptan ve perakende baralık ve topraklamalık bakır malzeme satışı. Elektrik pano sistemleri için.',
  `${BASE_URL}/tr/urunlerimiz/bakir/baralik-ve-topraklamalik-malzeme`,
  'https://www.e-metal.com.tr/static/media/baralik-ve-topraklamalik-malzeme.4aa5fa6493445ccf424e.png',
);

// --- COPPER ---
export const copperPipeSchema = createProductSchema(
  'Copper Pipe',
  'Wholesale and retail copper pipe sales. High quality copper pipe for electrical, heating and cooling systems.',
  `${BASE_URL}/en/our-products/copper/copper-pipe`,
  'https://www.e-metal.com.tr/static/media/bakir-boru.d78d4b2c73c42c7ae3ca.png',
);

// export const copperRodSchema = createProductSchema(
//   'Copper Rod',
//   'Wholesale and retail copper rod sales. High conductivity copper rod varieties.',
//   `${BASE_URL}/en/our-products/copper/copper-rod`,
//   'https://www.e-metal.com.tr/static/media/bakir-cubuk.c8f38262755011311999.png',
// );

// export const copperSquareRodSchema = createProductSchema(
//   'Copper Square Rod',
//   'Wholesale and retail copper square rod sales. Copper square rod in various cross-section sizes.',
//   `${BASE_URL}/en/our-products/copper/copper-square-rod`,
//   'https://www.e-metal.com.tr/static/media/bakir-kare-cubuk.645ee5ab50bf9f92e1e8.png',
// );

export const copperCoilPipeSchema = createProductSchema(
  'Copper Coil Pipe',
  'Wholesale and retail copper coil pipe sales. Copper coil pipe used in air conditioning and cooling systems.',
  `${BASE_URL}/en/our-products/copper/copper-coil-pipe`,
  'https://www.e-metal.com.tr/static/media/bakir-kangal-boru.dd4302a10f25aee7944a.png',
);

// export const copperWeldingWireSchema = createProductSchema(
//   'Copper Welding Wire',
//   'Wholesale and retail copper welding wire sales. High conductivity copper welding wire varieties.',
//   `${BASE_URL}/en/our-products/copper/copper-welding-wire`,
// );

export const copperBusbarSchema = createProductSchema(
  'Copper Busbar',
  'Wholesale and retail copper busbar sales. Copper busbar for electrical panel and busbar systems.',
  `${BASE_URL}/en/our-products/copper/copper-busbar`,
  'https://www.e-metal.com.tr/static/media/bakir-lama.bb88238a18b4a7082e3c.png',
);

export const copperSheetSchema = createProductSchema(
  'Copper Sheet',
  'Wholesale and retail copper sheet sales. Copper sheet in various thicknesses and sizes.',
  `${BASE_URL}/en/our-products/copper/copper-sheet`,
  'https://www.e-metal.com.tr/static/media/bakir-levha.bf81083fdd550df943e1.png',
);

export const copperStripsSchema = createProductSchema(
  'Copper Strips',
  'Wholesale and retail copper strips sales. Copper strips for transformer and electrical applications.',
  `${BASE_URL}/en/our-products/copper/copper-strips`,
  'https://www.e-metal.com.tr/static/media/bakir-serit.b47b02df0221a83693e7.png',
);

export const groundingMaterialSchema = createProductSchema(
  'Grounding and Busbar Material',
  'Wholesale and retail grounding and busbar copper material sales. For electrical panel systems.',
  `${BASE_URL}/en/our-products/copper/grounding-and-busbar-material`,
  'https://www.e-metal.com.tr/static/media/baralik-ve-topraklamalik-malzeme.4aa5fa6493445ccf424e.png',
);

// --- PİRİNÇ ---
export const pirincCubukSchema = createProductSchema(
  'Pirinç Çubuk',
  'Toptan ve perakende pirinç çubuk satışı. Makine imalatı ve döküm için yüksek kaliteli pirinç çubuk.',
  `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-cubuk`,
  'https://www.e-metal.com.tr/static/media/pirinc-cubuk.a6d4638e4096d8161c3d.png',
);

// export const pirincAltikoseCubukSchema = createProductSchema(
//   'Pirinç Altıköşe Çubuk',
//   'Toptan ve perakende pirinç altıköşe çubuk satışı. CNC işleme ve vida imalatı için pirinç altıköşe çubuk.',
//   `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-altikose-cubuk`,
//   'https://www.e-metal.com.tr/static/media/pirinc-altikose-cubuk.2b89e24f423843fa70f3.png',
// );

// export const pirincKareCubukSchema = createProductSchema(
//   'Pirinç Kare Çubuk',
//   'Toptan ve perakende pirinç kare çubuk satışı. Farklı kesit ölçülerinde pirinç kare çubuk.',
//   `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-kare-cubuk`,
//   'https://www.e-metal.com.tr/static/media/pirinc-kare-cubuk.5386079dfbbc56c58813.png',
// );

// export const pirincKaynakTeliSchema = createProductSchema(
//   'Pirinç Kaynak Teli',
//   'Toptan ve perakende pirinç kaynak teli satışı. Bakır ve çelik yüzey kaplaması için pirinç kaynak teli.',
//   `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-kaynak-teli`,
//   'https://www.e-metal.com.tr/static/media/pirinc-kaynak-teli.e22f8b2dfb5c53fd3ec7.png',
// );

export const pirincLamaSchema = createProductSchema(
  'Pirinç Lama',
  'Toptan ve perakende pirinç lama satışı. Dekoratif ve endüstriyel uygulamalar için pirinç lama.',
  `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-lama`,
  'https://www.e-metal.com.tr/static/media/pirinc-lama.34171cb658463dccdabc.png',
);

// export const pirincLevhaSchema = createProductSchema(
//   'Pirinç Levha',
//   'Toptan ve perakende pirinç levha satışı. Farklı kalınlık ve boyutlarda pirinç levha.',
//   `${BASE_URL}/tr/urunlerimiz/pirinc/pirinc-levha`,
//   'https://www.e-metal.com.tr/static/media/pirinc-levha.42c947a6007154a3009f.png',
// );

// --- BRASS ---
export const brassRodSchema = createProductSchema(
  'Brass Rod',
  'Wholesale and retail brass rod sales. High quality brass rod for machine manufacturing and casting.',
  `${BASE_URL}/en/our-products/brass/brass-rod`,
  'https://www.e-metal.com.tr/static/media/pirinc-cubuk.a6d4638e4096d8161c3d.png',
);

// export const brassHexagonalRodSchema = createProductSchema(
//   'Brass Hexagonal Rod',
//   'Wholesale and retail brass hexagonal rod sales. Brass hexagonal rod for CNC machining and bolt manufacturing.',
//   `${BASE_URL}/en/our-products/brass/brass-hexagonal-rod`,
//   'https://www.e-metal.com.tr/static/media/pirinc-altikose-cubuk.2b89e24f423843fa70f3.png',
// );

// export const brassSquareRodSchema = createProductSchema(
//   'Brass Square Rod',
//   'Wholesale and retail brass square rod sales. Brass square rod in various cross-section sizes.',
//   `${BASE_URL}/en/our-products/brass/brass-square-rod`,
//   'https://www.e-metal.com.tr/static/media/pirinc-kare-cubuk.5386079dfbbc56c58813.png',
// );

// export const brassWeldingWireSchema = createProductSchema(
//   'Brass Welding Wire',
//   'Wholesale and retail brass welding wire sales. Brass welding wire for copper and steel surface coating.',
//   `${BASE_URL}/en/our-products/brass/brass-welding-wire`,
//   'https://www.e-metal.com.tr/static/media/pirinc-kaynak-teli.e22f8b2dfb5c53fd3ec7.png',
// );

export const brassBusbarSchema = createProductSchema(
  'Brass Busbar',
  'Wholesale and retail brass busbar sales. Brass busbar for decorative and industrial applications.',
  `${BASE_URL}/en/our-products/brass/brass-busbar`,
  'https://www.e-metal.com.tr/static/media/pirinc-lama.34171cb658463dccdabc.png',
);

// export const brassSheetSchema = createProductSchema(
//   'Brass Sheet',
//   'Wholesale and retail brass sheet sales. Brass sheet in various thicknesses and sizes.',
//   `${BASE_URL}/en/our-products/brass/brass-sheet`,
//   'https://www.e-metal.com.tr/static/media/pirinc-levha.42c947a6007154a3009f.png',
// );

// --- ALÜMİNYUM ---
export const aluminyumCubukSchema = createProductSchema(
  'Alüminyum Çubuk',
  'Toptan ve perakende alüminyum çubuk satışı. Hafif ve dayanıklı alüminyum çubuk çeşitleri.',
  `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-cubuk`,
  'https://www.e-metal.com.tr/static/media/aluminyum-cubuk.ab0d133911de2b7a5ec3.png',
);

// export const aluminyumKareCubukSchema = createProductSchema(
//   'Alüminyum Kare Çubuk',
//   'Toptan ve perakende alüminyum kare çubuk satışı. Farklı kesit ölçülerinde alüminyum kare çubuk.',
//   `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-kare-cubuk`,
//   'https://www.e-metal.com.tr/static/media/aluminyum-kare-cubuk.341968654132c1bd1a6f.png',
// );

export const aluminyumLamaSchema = createProductSchema(
  'Alüminyum Lama',
  'Toptan ve perakende alüminyum lama satışı. İnşaat ve makine imalatı için alüminyum lama.',
  `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-lama`,
  'https://www.e-metal.com.tr/static/media/aluminyum-lama.f97c69b822bb17361dd1.png',
);

export const aluminyumLevhaSchema = createProductSchema(
  'Alüminyum Levha',
  'Toptan ve perakende alüminyum levha satışı. Farklı kalınlık ve boyutlarda alüminyum levha.',
  `${BASE_URL}/tr/urunlerimiz/aluminyum/aluminyum-levha`,
  'https://www.e-metal.com.tr/static/media/aluminyum-levha.48e55fa599eefe9f59d3.png',
);

// --- ALUMINUM ---
export const aluminumRodSchema = createProductSchema(
  'Aluminum Rod',
  'Wholesale and retail aluminum rod sales. Lightweight and durable aluminum rod varieties.',
  `${BASE_URL}/en/our-products/aluminum/aluminum-rod`,
  'https://www.e-metal.com.tr/static/media/aluminyum-cubuk.ab0d133911de2b7a5ec3.png',
);

// export const aluminumSquareRodSchema = createProductSchema(
//   'Aluminum Square Rod',
//   'Wholesale and retail aluminum square rod sales. Aluminum square rod in various cross-section sizes.',
//   `${BASE_URL}/en/our-products/aluminum/aluminum-square-rod`,
//   'https://www.e-metal.com.tr/static/media/aluminyum-kare-cubuk.341968654132c1bd1a6f.png',
// );

export const aluminumBusbarSchema = createProductSchema(
  'Aluminum Busbar',
  'Wholesale and retail aluminum busbar sales. Aluminum busbar for construction and machine manufacturing.',
  `${BASE_URL}/en/our-products/aluminum/aluminum-busbar`,
  'https://www.e-metal.com.tr/static/media/aluminyum-lama.f97c69b822bb17361dd1.png',
);

export const aluminumSheetSchema = createProductSchema(
  'Aluminum Sheet',
  'Wholesale and retail aluminum sheet sales. Aluminum sheet in various thicknesses and sizes.',
  `${BASE_URL}/en/our-products/aluminum/aluminum-sheet`,
  'https://www.e-metal.com.tr/static/media/aluminyum-levha.48e55fa599eefe9f59d3.png',
);

// --- BRONZ ---
export const bronzCubukSchema = createProductSchema(
  'Bronz Çubuk',
  'Toptan ve perakende bronz çubuk satışı. Yüksek dayanımlı bronz çubuk çeşitleri.',
  `${BASE_URL}/tr/urunlerimiz/bronz/bronz-cubuk`,
  'https://www.e-metal.com.tr/static/media/bronz-boru.d05d390f139b0d65603f.png',
);

// --- BRONZE ---
export const bronzeRodSchema = createProductSchema(
  'Bronze Rod',
  'Wholesale and retail bronze rod sales. High strength bronze rod varieties.',
  `${BASE_URL}/en/our-products/bronze/bronze-rod`,
  'https://www.e-metal.com.tr/static/media/bronz-boru.d05d390f139b0d65603f.png',
);

type ListItemSchema = {
  '@type': 'ListItem';
  position: number;
  name: string;
  url: string;
};

type ItemListSchema = {
  '@context': 'https://schema.org';
  '@type': 'ItemList';
  name: string;
  description: string;
  url: string;
  itemListElement: ListItemSchema[];
};

const mergeItemListSchemas = (
  name: string,
  description: string,
  url: string,
  schemas: ItemListSchema[],
): ItemListSchema => {
  const itemListElement = schemas
    .flatMap((schema) => schema.itemListElement)
    .map((item, index) => ({
      ...item,
      position: index + 1,
    }));

  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name,
    description,
    url,
    itemListElement,
  };
};

export const homeTrSchema = mergeItemListSchemas(
  'Metal Ürünleri',
  'Bakır, pirinç, alüminyum ve bronz ürün kategorileri',
  `${BASE_URL}/tr/anasayfa`,
  [
    bakırKategoriSchema,
    pirincKategoriSchema,
    aluminyumKategoriSchema,
    bronzKategoriSchema,
  ],
);

export const homeEnSchema = mergeItemListSchemas(
  'Metal Products',
  'Copper, brass, aluminum and bronze product categories',
  `${BASE_URL}/en/home`,
  [
    copperCategorySchema,
    brassCategorySchema,
    aluminumCategorySchema,
    bronzeCategorySchema,
  ],
);

export const schemaMap: Record<string, object> = {
  '/tr/anasayfa': homeTrSchema,
  '/en/home': homeEnSchema,

  // ── KATEGORİLER ──────────────────────────────
  '/tr/urunlerimiz/bakir': bakırKategoriSchema,
  '/tr/urunlerimiz/pirinc': pirincKategoriSchema,
  '/tr/urunlerimiz/aluminyum': aluminyumKategoriSchema,
  '/tr/urunlerimiz/bronz': bronzKategoriSchema,

  // ── BAKIR ────────────────────────────────────
  '/tr/urunlerimiz/bakir/bakir-boru': bakırBoruSchema,
  '/tr/urunlerimiz/bakir/bakir-kangal-boru': bakırKangalBoruSchema,
  '/tr/urunlerimiz/bakir/bakir-lama': bakırLamaSchema,
  '/tr/urunlerimiz/bakir/bakir-levha': bakırLevhaSchema,
  '/tr/urunlerimiz/bakir/bakir-seritler': bakırSeritlerSchema,
  '/tr/urunlerimiz/bakir/baralik-ve-topraklamalik-malzeme':
    baralikMalzemeSchema,

  // ── PİRİNÇ ───────────────────────────────────
  '/tr/urunlerimiz/pirinc/pirinc-cubuk': pirincCubukSchema,
  '/tr/urunlerimiz/pirinc/pirinc-lama': pirincLamaSchema,

  // ── ALÜMİNYUM ────────────────────────────────
  '/tr/urunlerimiz/aluminyum/aluminyum-cubuk': aluminyumCubukSchema,
  '/tr/urunlerimiz/aluminyum/aluminyum-lama': aluminyumLamaSchema,
  '/tr/urunlerimiz/aluminyum/aluminyum-levha': aluminyumLevhaSchema,

  // ── BRONZ ────────────────────────────────────
  '/tr/urunlerimiz/bronz/bronz-cubuk': bronzCubukSchema,

  // ── EN CATEGORIES ────────────────────────────
  '/en/our-products/copper': copperCategorySchema,
  '/en/our-products/brass': brassCategorySchema,
  '/en/our-products/aluminum': aluminumCategorySchema,
  '/en/our-products/bronze': bronzeCategorySchema,

  // ── EN COPPER ────────────────────────────────
  '/en/our-products/copper/copper-pipe': copperPipeSchema,
  '/en/our-products/copper/copper-coil-pipe': copperCoilPipeSchema,
  '/en/our-products/copper/copper-busbar': copperBusbarSchema,
  '/en/our-products/copper/copper-sheet': copperSheetSchema,
  '/en/our-products/copper/copper-strips': copperStripsSchema,
  '/en/our-products/copper/grounding-and-busbar-material':
    groundingMaterialSchema,

  // ── EN BRASS ─────────────────────────────────
  '/en/our-products/brass/brass-rod': brassRodSchema,
  '/en/our-products/brass/brass-busbar': brassBusbarSchema,

  // ── EN ALUMINUM ──────────────────────────────
  '/en/our-products/aluminum/aluminum-rod': aluminumRodSchema,
  '/en/our-products/aluminum/aluminum-busbar': aluminumBusbarSchema,
  '/en/our-products/aluminum/aluminum-sheet': aluminumSheetSchema,

  // ── EN BRONZE ────────────────────────────────
  '/en/our-products/bronze/bronze-rod': bronzeRodSchema,
};

export const metaMap: Record<string, {title: string; description: string}> = {
  '/tr/urunlerimiz/bakir': {
    title: 'Bakır Ürünleri | e-Metal',
    description:
      'Bakır nedir, kullanım alanları nelerdir ve bakır ürün çeşitleri hakkında bilgi alın. Bakır boru, bakır lama, bakır levha ve diğer ürünler e-Metal’de.',
  },
  '/tr/urunlerimiz/pirinc': {
    title: 'Pirinç Ürünleri | e-Metal',
    description:
      'Pirinç nedir, kullanım alanları nelerdir ve pirinç ürün çeşitleri hakkında bilgi alın.',
  },
  '/tr/urunlerimiz/aluminyum': {
    title: 'Alüminyum Ürünleri | e-Metal',
    description:
      'Alüminyum nedir, kullanım alanları nelerdir ve alüminyum ürün çeşitleri hakkında bilgi alın. Alüminyum çubuk, alüminyum lama ve alüminyum levha ürünleri e-Metal’de.',
  },
  '/tr/urunlerimiz/bronz': {
    title: 'Bronz Ürünleri | e-Metal',
    description:
      'Bronz nedir, kullanım alanları nelerdir ve bronz ürün çeşitleri hakkında bilgi alın. Bronz çubuk ürünleri için e-Metal’i inceleyin.',
  },
  '/en/our-products/copper': {
    title: 'Copper Products | e-Metal',
    description:
      'Learn what copper is, where it is used, and explore copper product types. Discover copper pipe, copper busbar, copper sheet, and more at e-Metal.',
  },
  '/en/our-products/brass': {
    title: 'Brass Products | e-Metal',
    description:
      'Learn what brass is, where it is used, and explore brass product types. Discover brass rods, brass busbars, and more at e-Metal.',
  },
  '/en/our-products/aluminum': {
    title: 'Aluminum Products | e-Metal',
    description:
      'Learn what aluminum is, where it is used, and explore aluminum product types. Discover aluminum rods, aluminum busbars, and aluminum sheets at e-Metal.',
  },
  '/en/our-products/bronze': {
    title: 'Bronze Products | e-Metal',
    description:
      'Learn what bronze is, where it is used, and explore bronze product types. Discover bronze rod products at e-Metal.',
  },
};
